import React from 'react';

import bridge from '~/utils/bridge';
import isMobile from '~/utils/is-mobile';

import main from './images/main.mp4';

import { Wrap, VideoWrap } from './styled';

function Introduce3DView() {
  function clickMap() {
    const url = 'dabang://map';

    bridge.web(_ => {
      console.log('web');
      if (isMobile.Android()) return window.location.href = 'market://details?id=kr.co.station3.dabang';
      if (isMobile.IOS()) return window.location.href = 'https://itunes.apple.com/kr/app/id814840066';

      window.location.href = `https://dabangapp.com/search/map`;
    });

    bridge.android(call => {
      console.log('android');
      call.openBrowser(url);
    });

    bridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openBrowser',
        url: url,
      });
    });
  }

  return (
    <Wrap>
      <VideoWrap width={710} height={2286}>
        <video autoPlay muted loop playsInline width="100%" height="100%" preload="auto">
          <source src={main} type="video/mp4" />
        </video>

        <button onClick={clickMap} />
      </VideoWrap>
    </Wrap>
  );
}

export default Introduce3DView;
